import React, { useState, useEffect, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import DynamicSwimlane from './DynamicSwimlane'
import StaticSwimlane from './StaticSwimlane'
import { isEmpty } from 'src/views/utils/helper'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { CONTENT_LIST_API } from 'src/views/utils/urls'
import Loading from 'react-fullscreen-loading'

const SwimlaneModal = ({
  openModal,
  subCategories,
  categories,
  countries,
  customMetadataMaster,
  customMetadata,
  subscriptions,
  swimlaneCallback,
  selectedSwimlane,
  onCancel,
}) => {
  const [contentArray, setContentArray] = useState([])
  const [staticContentArray, setStaticContentArray] = useState([])

  const [typeSwimlane, setTypeSwimlane] = useState('DYNAMIC')
  const [sectionName, setSectionName] = useState('')
  // const [contentLimit, setContentLimit] = useState('')

  const [filters, setFilters] = useState({})
  const [editFilters, setEditFilters] = useState({})

  const [errorData, setErrorData] = useState({})

  const editFlag = !isEmpty(selectedSwimlane)
  const language = localStorage.getItem('language')
  const { accountObj, setLoader, loader, setContentModalProps } = useContext(AppContext)
  const defaultLangCheck = language === accountObj?.default_language

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      let tempContentArr = []
      let tempContentIds = []
      selectedSwimlane.contents.forEach((element) => {
        const contentObj = contentList.data.find((obj) => obj._id === element)
        if (contentObj) {
          tempContentArr.push(contentObj)
          tempContentIds.push(contentObj._id)
        }
      })
      setStaticContentArray(tempContentArr)
      setContentArray(tempContentIds)
    }
  }, [contentList])

  useEffect(() => {
    if (editFlag) {
      handleEdit()
    }
  }, [selectedSwimlane])

  const handleEdit = () => {
    setTypeSwimlane(selectedSwimlane.type)
    setSectionName(selectedSwimlane.name)
    // setContentLimit(selectedSwimlane.limit)
    if (selectedSwimlane.hasOwnProperty('filters')) {
      setEditFilters(selectedSwimlane.filters)
    }
    if (selectedSwimlane.hasOwnProperty('contents')) {
      setContentArray(selectedSwimlane.contents)

      contentListCall({
        params: {
          content_id: selectedSwimlane.contents.toString(),
        },
      })
    }
  }
  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    // if (!contentLimit || contentLimit < 0) {
    //   isFormValid = false
    //   temp.contentLimit = 'Enter Valid Limit!'
    // }
    if (!sectionName && sectionName.trim.length === 0) {
      isFormValid = false
      temp.sectionName = 'Enter Name!'
    }
    if (typeSwimlane === 'STATIC' && isEmpty(contentArray)) {
      isFormValid = false
      temp.contentArray = 'Select Content!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSubmit = () => {
    if (!validateInfo()) return

    let swimlaneObj = {
      type: typeSwimlane,
      name: sectionName,
      // limit: contentLimit,
    }

    typeSwimlane === 'STATIC'
      ? (swimlaneObj[`contents`] = contentArray)
      : (swimlaneObj[`filters`] = filters)

    swimlaneCallback(swimlaneObj)
  }

  const openContentModal = () => {
    setContentModalProps({
      type: 'multiple',
      mappedContentId: contentArray,
      mappedContentArray: staticContentArray,
      selectCallback: (contentId, contents) => {
        setContentArray(contentId)
        setStaticContentArray(contents)
      },
    })
  }

  return (
    <>
      <CModal size="xl" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            <p className="h4">{editFlag ? `Edit ` : `Add New `}Swimlane section</p>
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="py-4">
          <CRow style={{ fontSize: '3rem' }} className="px-5 mt-3">
            <CCol lg="3">
              <CFormCheck
                type="radio"
                name="swimRadioDefault"
                label="Auto Generated"
                className="swimlane-options"
                checked={typeSwimlane === 'DYNAMIC'}
                onClick={() => setTypeSwimlane('DYNAMIC')}
                disabled={!defaultLangCheck}
              />
            </CCol>
            <CCol>
              <CFormCheck
                type="radio"
                name="swimRadioDefault"
                label="Manually Generated"
                className="swimlane-options"
                checked={typeSwimlane === 'STATIC'}
                onClick={() => setTypeSwimlane('STATIC')}
                disabled={!defaultLangCheck}
              />
            </CCol>
          </CRow>
          <CRow className="px-5 mt-3">
            <CCol lg="2">
              <p className="h5 mt-2">Section Name*</p>
            </CCol>
            <CCol lg="9">
              <CFormInput
                type="text"
                value={sectionName}
                name="sectionName"
                placeholder="Enter Section Name"
                onChange={(e) => setSectionName(e.target.value)}
              />
              <div className="message-text error-message">
                <p>{errorData.sectionName}</p>
              </div>
            </CCol>
          </CRow>
          {/* <CRow className="px-5 mt-3">
            <CCol lg="2">
              <p className="h5 mt-2">Content Limit*</p>
            </CCol>
            <CCol lg="9">
              <CFormInput
                type="number"
                min="1"
                value={contentLimit}
                name="contentLimit"
                onChange={(e) => setContentLimit(e.target.value)}
              />
              <div className="message-text error-message">
                <p>{errorData.contentLimit}</p>
              </div>
            </CCol>
          </CRow> */}
          <CRow className="mt-4">
            <hr />
          </CRow>
          <CRow className="px-5 mt-3">
            {typeSwimlane === 'DYNAMIC' ? (
              <DynamicSwimlane
                subCategories={subCategories}
                categories={categories}
                countries={countries}
                customMetadataMaster={customMetadataMaster}
                customMetadata={customMetadata}
                subscriptions={subscriptions}
                setFilterPayload={setFilters}
                editData={editFilters}
              />
            ) : (
              <StaticSwimlane
                contentModal={openContentModal}
                addedcotentData={staticContentArray}
                updateAddedContent={setStaticContentArray}
                contentPayload={contentArray}
                setContentPayload={setContentArray}
              />
            )}
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSubmit}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default SwimlaneModal
